export const CTA_TEXT_GET_STARTED = 'GET STARTED'
export const CTA_TEXT_COMPARE_CARDS = 'COMPARE CARDS'
export const CTA_TEXT_COMPARE_LOANS = 'COMPARE LOANS'

export const CTA_TEXT_FIND_MY_DEAL = 'FIND MY DEAL'
export const CTA_TEXT_COMPARE_INSURANCE = 'COMPARE INSURANCE'
